module.exports = __webpack_public_path__ + "img/pvc_expomoda_0005_dark_grey.b869f147.jpg";